// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    width: fit-content;
}

    .radio-group.column {
        flex-direction: column;
    }

.radio-item-container {
    display: flex;
    align-items: center; /* <-- This is the key */
    flex-wrap: nowrap; /* <-- Prevents wrapping from breaking alignment */
    width: fit-content;
    gap: 0.5rem; /* Optional: cleaner spacing */
}

.radio-item {
    display: flex;
    align-items: center;
    border: 2px solid var(--rg-border);
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    cursor: pointer;
    user-select: none;
    transition: background 0.15s ease, border-color 0.15s ease;
}

    .radio-item.checked {
        background: var(--rg-background);
        border-color: var(--rg-border);
    }

    .radio-item:hover {
        box-shadow: 0 0 8px 3px var(--rg-hover);
    }

.radio-input {
    display: none;
}

.radio-label {
    font-size: inherit;
    margin-left: 0.5rem;
    height: fit-content;
}
`, "",{"version":3,"sources":["webpack://./src/Controls/css/RadioGroup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,kBAAkB;AACtB;;IAEI;QACI,sBAAsB;IAC1B;;AAEJ;IACI,aAAa;IACb,mBAAmB,EAAE,wBAAwB;IAC7C,iBAAiB,EAAE,kDAAkD;IACrE,kBAAkB;IAClB,WAAW,EAAE,8BAA8B;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,0DAA0D;AAC9D;;IAEI;QACI,gCAAgC;QAChC,8BAA8B;IAClC;;IAEA;QACI,uCAAuC;IAC3C;;AAEJ;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".radio-group {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n    width: fit-content;\r\n}\r\n\r\n    .radio-group.column {\r\n        flex-direction: column;\r\n    }\r\n\r\n.radio-item-container {\r\n    display: flex;\r\n    align-items: center; /* <-- This is the key */\r\n    flex-wrap: nowrap; /* <-- Prevents wrapping from breaking alignment */\r\n    width: fit-content;\r\n    gap: 0.5rem; /* Optional: cleaner spacing */\r\n}\r\n\r\n.radio-item {\r\n    display: flex;\r\n    align-items: center;\r\n    border: 2px solid var(--rg-border);\r\n    width: 2rem;\r\n    height: 2rem;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    transition: background 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n    .radio-item.checked {\r\n        background: var(--rg-background);\r\n        border-color: var(--rg-border);\r\n    }\r\n\r\n    .radio-item:hover {\r\n        box-shadow: 0 0 8px 3px var(--rg-hover);\r\n    }\r\n\r\n.radio-input {\r\n    display: none;\r\n}\r\n\r\n.radio-label {\r\n    font-size: inherit;\r\n    margin-left: 0.5rem;\r\n    height: fit-content;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
